import { Form, Popover } from "antd";
import EmojiPicker from "emoji-picker-react";
import { Field, Formik } from "formik";
import _ from "lodash";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ActionIcons from "@/Components/common/client/ActionIcons";
import FieldErrorMessage from "@/Components/common/FieldErrorMessage";
import ModalPopUp from "@/Components/common/ModalPopUp";
import EmojiIcon from "@/Components/Icons/chat/EmojiIcon";
import { RejectIcon } from "@/Components/Icons/RejectIcon";
import {
  getChatTemplate,
  saveChatTemplate,
  toggleEditChatTemplateModal,
  updateClickedTemplate,
} from "@/reducers/chat";
import { _chatTemplatePlaceholder } from "@/utilities/utils";

// import { viewProfile } from "@/reducers/user";

import { _localSet } from "../../../../localStorage";
const EditChatTemplate = ({ value, setValue }) => {
  const {
    showEditChatTemplateModal,
    chatBoxes,
    chatTemplateObj,
    clickedTemplate,
  } = useSelector((state) => state.chat);
  const [disabledAddBtn, setDisabledAddBtn] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dispatch = useDispatch();
  const handleClose = (makeTextareaFocus = false) => {
    dispatch(toggleEditChatTemplateModal(false));
    if (makeTextareaFocus) {
      _localSet("chatDetailTextareaFocus", true);
    }
  };

  const textareaRef = useRef(null);

  const getPreviewMessage = (msg) => {
    if (chatBoxes[0].for_template) {
      let forTemplate = chatBoxes[0].for_template;
      let tempMessage = msg;
      Object.keys(forTemplate).forEach((key) => {
        tempMessage = tempMessage.replaceAll(`${key}`, forTemplate[key]);
      });
      return tempMessage;
    }
    return msg;
  };
  return (
    <ModalPopUp
      show={showEditChatTemplateModal}
      panelClass="max-w-[1000px] overflow-hidden"
      onClose={() => {
        handleClose();
      }}
      panelContainerClass="2xl:flex 2xl:justify-center 2xl:items-center"
    >
      <div className="grid gap-6">
        <div className="grid gap-[12px]">
          <div className="flex justify-between">
            <h3 className="text-[20px] font-semibold leading-[normal] text-black">
              Edit Chat Template
            </h3>
            <button
              onClick={handleClose}
              className="text-red outline-none ring-0"
            >
              <RejectIcon />
            </button>
          </div>
          <div>
            <Formik
              initialValues={{
                name: chatTemplateObj.name,
                message: chatTemplateObj.message,
                id: chatTemplateObj.id,
              }}
              validateOnChange={false}
              validateOnBlur={false}
              validateOnMount={false}
              validate={(values) => {
                const errors = {};
                if (!values.name) {
                  errors.name = "Template Name is required";
                }
                if (!values.message) {
                  errors.message = "Template Message is required";
                }
                return errors;
              }}
              onSubmit={(values, { setSubmitting }) => {
                if (isSubmitting) {
                  return;
                }
                setIsSubmitting(true);
                setDisabledAddBtn(true);
                setSubmitting(true);
                const updateInTextarea = () => {
                  if (_.isEmpty(clickedTemplate)) return;
                  let forTemplate = chatBoxes[0].for_template;
                  let tempMessage = values.message;
                  Object.keys(forTemplate).forEach((key) => {
                    tempMessage = tempMessage.replaceAll(
                      `${key}`,
                      forTemplate[key],
                    );
                  });
                  setValue(tempMessage);
                };
                const callback = () => {
                  dispatch(getChatTemplate());
                  setSubmitting(false);
                  updateInTextarea();
                  var template = { ...clickedTemplate };
                  dispatch(
                    updateClickedTemplate({
                      ...template,
                      mailshot_name: values.name,
                      mailshot_text: values.message,
                    }),
                  );
                  handleClose(true);
                };
                const _postData = {
                  template_name: values.name,
                  template_message: values.message,
                  template_id: values.id,
                  is_update: 1,
                  callback,
                };

                dispatch(
                  saveChatTemplate({
                    _postData: _postData,
                    callback: callback,
                    setIsSubmitting: setIsSubmitting,
                    setDisabledAddBtn: setDisabledAddBtn,
                  }),
                );
                // dispatch(saveChatTemplate(_postData));
              }}
            >
              {({
                submitForm,
                // isSubmitting,
                errors,
                touched,
                isValid,
                values,
                setFieldValue,
              }) => (
                <Form>
                  <div className="flex flex-col gap-6">
                    <div className="grid grid-cols-1 gap-x-6 sm:grid-cols-2">
                      <div className="grid gap-4">
                        <div className="grid gap-3">
                          <label
                            htmlFor="name"
                            className="label !font-normal text-black"
                          >
                            Template Name
                          </label>
                          <div className="flex flex-col gap-1">
                            <Field
                              type="text"
                              className={`h-[40px] w-full rounded-lg border border-lightGrey px-4 !outline-none !ring-0 focus:border-primary ${
                                errors.name && touched.name
                                  ? "!border-red-500"
                                  : ""
                              }`}
                              autoComplete="off"
                              name="name"
                              placeholder="Enter Template Name"
                              onKeyUp={(e) => {
                                if (e.keyCode === 13) {
                                  submitForm();
                                }
                              }}
                            />
                            <FieldErrorMessage name="name" />
                          </div>
                        </div>
                        <div className="grid gap-3">
                          <label
                            htmlFor="message"
                            className="label !font-normal text-black"
                          >
                            Message
                          </label>
                          <div className="flex flex-col gap-1">
                            <div className="relative">
                              <textarea
                                name="messgae"
                                className="ease max-h-[400px] min-h-[64px] w-full rounded-lg border border-lightGrey py-3 pl-4 pr-9 text-[14px] font-medium leading-[normal] text-black !outline-none !ring-0 transition-all duration-200 placeholder:font-medium placeholder:text-txtColor focus:border-primary"
                                value={values.message}
                                onChange={(e) => {
                                  setFieldValue("message", e.target.value);
                                }}
                                placeholder="Enter Message"
                                ref={textareaRef}
                              />
                              <div className="absolute right-3 top-4">
                                <Popover
                                  rootClassName="z-[1033]"
                                  trigger={"click"}
                                  content={
                                    <EmojiPicker
                                      onEmojiClick={(emojiObject, event) => {
                                        var newText =
                                          values.message + emojiObject.emoji;
                                        setFieldValue("message", newText);

                                        // handleTextChange(event,emojiObject.emoji)
                                      }}
                                      lazyLoadEmojis={true}
                                      // skinTonesDisabled={true}
                                    />
                                  }
                                >
                                  <button className="flex cursor-pointer place-items-center gap-3 text-txtColor">
                                    <EmojiIcon cls="text-txtColor" />
                                  </button>
                                </Popover>
                              </div>
                            </div>
                            <FieldErrorMessage name="message" />
                          </div>
                        </div>
                        <div className="grid gap-3">
                          <label
                            htmlFor="message"
                            className="label !font-normal text-black"
                          >
                            Insert Placeholder
                          </label>
                          <p className="text-[14px] font-semibold">
                            Use below codes to include ref no, candidate name,
                            candidate email in message.
                          </p>
                          <div className="flex flex-wrap gap-3">
                            {_chatTemplatePlaceholder
                              .filter(
                                (title) => title !== "candidate_full_name",
                              )
                              .map((ele, index) => {
                                return (
                                  <>
                                    <div
                                      role="button"
                                      className="rounded-lg border border-primary bg-lightblue px-3 py-1 text-primary"
                                      key={index}
                                      onClick={() => {
                                        var $textarea = textareaRef.current;
                                        var $curVal = values.message;
                                        var curPos = $textarea.selectionStart;
                                        var newText = `${$curVal.slice(0, curPos)} ${ele} ${$curVal.slice(curPos)}`;
                                        setFieldValue("message", newText);
                                        $textarea.focus();
                                        setTimeout(() => {
                                          $textarea.selectionStart =
                                            curPos + ele.length + 2;
                                          $textarea.selectionEnd =
                                            curPos + ele.length + 2;
                                        }, 50);
                                      }}
                                    >
                                      {ele}
                                    </div>
                                  </>
                                );
                              })}
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="flex h-full flex-col justify-start gap-3">
                          <label
                            htmlFor="message"
                            className="label !font-normal text-black"
                          >
                            Preview
                          </label>
                          <div className="flex flex-1 flex-col">
                            <textarea
                              name="messgae"
                              className="ease h-full max-h-full min-h-[64px] w-full resize-none rounded-lg border !border-lightGrey px-4 py-3 text-[14px] font-medium leading-[normal] text-black !outline-none !ring-0 focus:!ring-lightGrey"
                              value={getPreviewMessage(values.message)}
                              readOnly
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-end gap-5">
                      <button
                        type="button"
                        className="transition-linear flex h-[40px] w-[120px] items-center justify-center rounded-lg border border-primary bg-primary text-white hover:bg-none hover:text-primary"
                        onClick={submitForm}
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <ActionIcons isLoading={"loading"} />
                        ) : (
                          <span>Update</span>
                        )}
                        {/* Update */}
                      </button>
                      <button
                        type="button"
                        className="transition-linear flex h-[40px] w-[120px] items-center justify-center rounded-lg border border-primary bg-none text-primary hover:bg-primary hover:text-white"
                        onClick={() => {
                          handleClose();
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </ModalPopUp>
  );
};

export default EditChatTemplate;
